import React, { useCallback, useEffect, useMemo, useState } from "react";
import { IoCloseOutline } from "react-icons/io5";

function ApiPage() {
  const [layer2table, setLayer2Table] = useState(0);
  const [layer1table, setLayer1Table] = useState(0);
  const [layer3table, setLayer3Table] = useState(0);
  const layer2Array = [
    {
      assetType: "Bank Accounts Switch",

      integration: "Finvu, Onemoney, NADL and Protean",

      rowSpan: 5,
      api: "networth",
    },
    {
      assetType: "Mutual Funds Switch",
      integration: "",
      api: "networth",
    },
    {
      assetType: "Stocks, Bonds Switch - NSDL",
      integration: "",
      api: "networth",
    },
    {
      assetType: "Stocks, Bonds Switch - CDSL",
      integration: "",
      api: "networth",
    },
    {
      assetType: "Insurance, NPS, GST, ITR",
      integration: "",
      api: "networth",
    },
    {
      assetType: "Consumer Durable Assets",
      integration: "AA-Finsire Analytics",
      rowSpan: 5,
      api: "networth",
    },
    {
      assetType: "Salary",
      integration: "",
      api: "networth",
    },
    {
      assetType: "Dividends and Interest Income",
      integration: "",
      api: "networth",
    },
    {
      assetType: "Rental Income",
      integration: "",
      api: "networth",
    },
    {
      assetType: "Rental Expenditure",
      integration: "",
      api: "networth",
    },
    {
      assetType: "Mutal Funds- CAS",
      integration: "CAMS",
      api: "networth",
    },
    {
      assetType: "Mutal Funds- CAS",
      integration: "KFintech",
      api: "networth",
    },
    {
      assetType: "Mutal Funds- CAS",
      integration: "MF Central",
      api: "networth",
    },
    {
      assetType: "Investments AI",
      integration: "AAs + Suite",
      api: "ourapi",
      rowSpan: 3,
      apiname: "Investment Assistant",
    },
    {
      assetType: "Loans AI",
      integration: "",

      api: "ourapi",
      apiname: "Loans and Underwriting",
    },
    {
      assetType: "Widget 1-5",
      integration: "",

      api: "ourapi",
      apiname: "User Engagement Widgets",
    },
    {
      assetType:
        "Income, Short Term/Long Term Capital Gains and Losses, Other income , Deductions",
      integration: "CAS+ Suite TBA by Sales",
      api: "ourapi",
      apiname: "Tax Analysis",
    },

    {
      assetType: "Mutual Fund",
      integration: "CAMS",
      rowSpanAPi: 5,

      api: "ourapi",
      apiname: "MFC Dashboard and Portfolio",
    },
    {
      assetType: "Mutual Fund",
      integration: "KFintech",

      api: "ourapi",
      apiname: "MFC Dashboard and Portfolio",
    },
    {
      assetType: "Mutual Fund",
      integration: "MF Central",

      api: "ourapi",
      apiname: "MFC Dashboard and Portfolio",
    },
    {
      assetType: "Stocks",
      integration: "NSDL",

      api: "ourapi",
      apiname: "MFC Dashboard and Portfolio",
    },
    {
      assetType: "Stocks",
      integration: "CDSL",

      api: "ourapi",
      apiname: "MFC Dashboard and Portfolio",
    },

    {
      assetType: "DSA for LAMF, LAS, LAI ",
      integration: "Bajaj Finance",

      api: "ourapi",
      apiname: "DSA Stack 1-Secured Lending",
    },
    {
      assetType: "DSA for LAMF, LAS, LAI ",
      integration: "Tata Capital",

      api: "ourapi",
      apiname: "DSA Stack 2-Secured Lending",
    },
  ];
  const layer1Array = [
    {
      assetType: "Pay Slip",
      integration: "Tartan",
      rowSpan: 2,
      api: "networth",
    },
    { assetType: "EPFO", integration: "", api: "networth" },
    {
      assetType: "Alternative KYC",
      integration: "Bureau ID",
      rowSpan: 2,
      api: "networth",
    },
    { assetType: "Subscriptions", integration: "", api: "networth" },
    {
      assetType: "GST",
      integration: "Corpository",
      rowSpan: 3,
      api: "networth",
    },

    { assetType: "ITR", integration: "", api: "networth" },
    { assetType: "MCA", integration: "", api: "networth" },
    {
      assetType: "GST",
      integration: "FinFort",
      rowSpan: 3,
      api: "networth",
    },

    { assetType: "ITR", integration: "", api: "networth" },
    { assetType: "MCA", integration: "", api: "networth" },
    {
      assetType: "Vehicle",
      integration: "Insured Declared Value Stack",
      api: "networth",
    },
    {
      assetType: "Real Estate",
      integration: "Self-Regulatory Organisation Stack",
      api: "networth",
    },
    {
      assetType: "Utilities",
      integration: "Utility Stack",
      api: "networth",
    },
    {
      assetType: "Education",
      integration: "LinkedIn Stack",
      rowSpan: 2,
      api: "networth",
    },
    {
      assetType: "Work Experience",
      integration: "",
      api: "networth",
    },
    {
      assetType: "Vehicle 360° View",
      integration: "3D Rendering Vehicles",
      api: "vehicle",
    },
    {
      assetType: "Insured Declared Value & Market Price",
      integration: "Vehicle Valuation",
      api: "vehicle",
    },
    {
      assetType: "Vahaan",
      integration: "Vehicle Detailed & Challan",
      api: "vehicle",
    },
  ];
  const layer3Array = [
    {
      assetType: "Stocks, Bonds and more - CAS",
      integration: "NSDL",

      api: "networth",
    },
    {
      assetType: "Stocks, Bonds and more - CAS",
      integration: "CSDL",

      api: "networth",
    },
    {
      assetType: "Credit Score",
      integration: "Cibil",

      api: "networth",
    },
    {
      assetType: "Credit Score",
      integration: "Experian",

      api: "networth",
    },

    {
      assetType: "One Vaahan",
      integration: "Hypothecation",

      api: "vehicle",
    },
    {
      assetType: "Partner",
      integration: "Re-hypothecation",

      api: "vehicle",
    },
    {
      assetType: "Mutual Fund Switch",
      integration: "CAMS",

      api: "loanagainstmutualfunds",
      apiname: "MF Repository Optimizer",
    },
    {
      assetType: "Mutual Fund Switch",
      integration: "KFintech",

      api: "loanagainstmutualfunds",
      apiname: "MF Repository Optimizer",
    },
    {
      assetType: "Mutual Fund Switch",
      integration: "MF Central",

      api: "loanagainstmutualfunds",
      apiname: "MF Repository Optimizer",
    },
    {
      assetType: "Mutual Funds-Secured Lending",
      integration: "CAMS",

      api: "loanagainstmutualfunds",
      apiname: "Pledge, Invoke, Revoke, LTV, Dashboards, Reconciliation",
    },
    {
      assetType: "Mutual Funds-Secured Lending",
      integration: "KFintech",

      api: "loanagainstmutualfunds",
      apiname: "Pledge, Invoke, Revoke, LTV, Dashboards, Reconciliation",
    },
    {
      assetType: "Mutual Funds-Secured Lending",
      integration: "MF Central",

      api: "loanagainstmutualfunds",
      apiname: "Pledge, Invoke, Revoke, LTV, Dashboards, Reconciliation",
    },

    {
      assetType: "Stocks, Bonds, Other Assets-Secured Lending",
      integration: "NSDL TP-LAS",

      api: "loanagainststocks",
      apiname: "Pledge, Invoke, Revoke, LTV, Dashboards, Reconciliation",
    },
    {
      assetType: "Stocks, Bonds, Other Assets-Secured Lending",
      integration: "CDSL DP-LAS",

      api: "loanagainststocks",
      apiname: "Pledge, Invoke, Revoke, LTV, Dashboards, Reconciliation",
    },
    {
      assetType: "Stocks, Bonds, Other Assets-Secured Lending",
      integration: "CDSL E-LAS",

      api: "loanagainststocks",
      apiname: "Pledge, Invoke, Revoke, LTV, Dashboards, Reconciliation",
    },
    {
      assetType: "Repository Asset Switch",
      integration: "NSDL",

      api: "loanagainststocks",
      apiname: "Securities Repository Optimizer",
    },
    {
      assetType: "Repository Asset Switch",
      integration: "CDSL",

      api: "loanagainststocks",
      apiname: "Securities Repository Optimizer",
    },
  ];

  const [subSectionPage, setSubSectionPage] = useState("networth");
  const subSectionsList = [
    "Net Worth",
    "Vehicle",
    "Loan Against Mutual Funds",
    "Loan Against Stocks",

    "Our API",
  ];

  let b = 1;
  const containsData = useCallback(
    (array, layerTable) => {
      const isFound = array.some((element) => element.api === subSectionPage);
      layerTable(isFound ? 1 : 0);
    },
    [layer1Array, layer2Array, layer3Array]
  );

  useEffect(() => {
    containsData(layer1Array, setLayer1Table);
    containsData(layer3Array, setLayer3Table);
    containsData(layer2Array, setLayer2Table);
    // for (let i = 0; i < layer2Array.length; i++) {
    //   if (layer2Array[i].api === subSectionPage) {
    //     setLayer2Table(1);
    //     break;
    //   } else {
    //     setLayer2Table(0);
    //   }
    // }
    //
  }, [subSectionPage]);

  return (
    <>
      <div className="flex items-center justify-between h-[45px] sticky top-0  z-10 bg-white">
        <div className="flex items-center text-sm ">
          <p className=" text-[#4f46e5] text-2xl font-semibold">API</p>
          <p className="px-4 font-normal text-lg -mb-0.5">
            <pre>{">"}</pre>
          </p>
          <div className="-mb-1 ml-2 flex items-center  overflow-x-auto whitespace-nowrap  ">
            {subSectionsList.map((subSection) => (
              <>
                <p
                  className={` !text-[16px] ${
                    subSection.toLowerCase().trim().replace(/\s/g, "") ===
                    subSectionPage
                      ? " bg-[#4e46e530] text-[#4f46e5]"
                      : " text-gray-400"
                  } px-3 py-1 cursor-pointer text-base`}
                  onClick={() => {
                    // console.log(subSection.toLowerCase().replace(/\s/g, ""));
                    setSubSectionPage(
                      subSection.toLowerCase().trim().replace(/\s/g, "")
                    );
                  }}
                >
                  {subSection}
                </p>
              </>
            ))}
          </div>
        </div>
      </div>
      {
        <div className="passwordchange-container">
          <div className="userlist-container">
            <div className="userlist-table-div flex  justify-between">
              {layer1table > 0 && (
                <table className="userlist-table api-table">
                  <thead>
                    <tr>
                      <th colSpan="2">
                        No License
                        {/* <p>Layer 1</p> */}
                      </th>
                    </tr>
                  </thead>
                  <thead className="!h-[30px]">
                    <tr>
                      <th>Asset Type</th>
                      <th>Integrations</th>
                    </tr>
                  </thead>
                  {layer1Array.map((item) => {
                    return (
                      item.api === subSectionPage && (
                        <tr className="right-border">
                          <td>{item.assetType}</td>
                          {item.integration && (
                            <td rowSpan={item.rowSpan}>{item.integration}</td>
                          )}
                        </tr>
                      )
                    );
                  })}
                </table>
              )}

              {layer2table > 0 && (
                <table className="userlist-table  api-table">
                  <thead>
                    <tr>
                      <th colSpan="3">
                        Licensed
                        <p>RBI, SEBI, IRDIA and PFRDA</p>
                      </th>
                    </tr>
                  </thead>
                  <thead className="!h-[30px]">
                    <tr className="text-lighter">
                      {subSectionPage === "ourapi" ? (
                        <>
                          {" "}
                          {subSectionPage === "ourapi" && <th>API Name</th>}
                          <th>Integrations</th>
                          <th>Asset Type</th>
                        </>
                      ) : (
                        <>
                          {" "}
                          <th>Asset Type</th>
                          <th>Integrations</th>
                          {subSectionPage === "ourapi" && <th>API Name</th>}
                        </>
                      )}
                    </tr>
                  </thead>
                  {layer2Array.map((item) => {
                    return (
                      item.api === subSectionPage && (
                        <tr className="right-border">
                          {subSectionPage === "ourapi" ? (
                            <>
                              {" "}
                              {subSectionPage === "ourapi" && (
                                <td>{item.apiname}</td>
                              )}
                              {item.integration && (
                                <td rowSpan={item.rowSpan}>
                                  {item.integration}
                                </td>
                              )}
                              <td>{item.assetType}</td>
                            </>
                          ) : (
                            <>
                              {" "}
                              <td>{item.assetType}</td>
                              {item.integration && (
                                <td rowSpan={item.rowSpan}>
                                  {item.integration}
                                </td>
                              )}
                              {subSectionPage === "ourapi" && (
                                <td>{item.apiname}</td>
                              )}
                            </>
                          )}
                        </tr>
                      )
                    );
                  })}
                </table>
              )}
              {layer3table > 0 && (
                <table className="userlist-table api-table">
                  <thead>
                    <tr>
                      <th colSpan="3">
                        Licensed +<p>RBI </p>
                      </th>
                    </tr>
                  </thead>
                  <thead className="!h-[30px]">
                    {subSectionPage === "loanagainstmutualfunds" ||
                    subSectionPage === "loanagainststocks" ? (
                      <>
                        <tr>
                          {(subSectionPage === "loanagainststocks" ||
                            subSectionPage === "loanagainstmutualfunds") && (
                            <th>API Name</th>
                          )}

                          <th>Integrations</th>
                          <th>Asset Type</th>
                        </tr>
                      </>
                    ) : (
                      <>
                        <tr>
                          <th>Asset Type</th>
                          <th>Integrations</th>
                          {(subSectionPage === "loanagainststocks" ||
                            subSectionPage === "loanagainstmutualfunds") && (
                            <th>API Name</th>
                          )}
                        </tr>
                      </>
                    )}
                  </thead>

                  {layer3Array.map(
                    (item) =>
                      item.api === subSectionPage && (
                        <tr className="right-border">
                          {subSectionPage === "loanagainststocks" ||
                          subSectionPage === "loanagainstmutualfunds" ? (
                            <>
                              {subSectionPage === "loanagainststocks" && (
                                <td>{item.apiname}</td>
                              )}
                              {subSectionPage === "loanagainstmutualfunds" && (
                                <td>{item.apiname}</td>
                              )}
                              {item.integration && (
                                <td rowSpan={item.rowSpan}>
                                  {item.integration}
                                </td>
                              )}

                              <td>{item.assetType}</td>
                            </>
                          ) : (
                            <>
                              <td>{item.assetType}</td>
                              {item.integration && (
                                <td rowSpan={item.rowSpan}>
                                  {item.integration}
                                </td>
                              )}
                              {subSectionPage === "loanagainststocks" && (
                                <td>{item.apiname}</td>
                              )}
                              {subSectionPage === "loanagainstmutualfunds" && (
                                <td>{item.apiname}</td>
                              )}
                            </>
                          )}
                        </tr>
                      )
                  )}
                </table>
              )}
            </div>
          </div>
        </div>
      }
    </>
  );
}

export default ApiPage;
